<template>
  <v-dialog
      v-model="dialog"
      :width="dialogWidth"
      @keydown.enter.prevent="save"
  >
    <v-card
        class="resizable-card"
        :class="{ 'no-select': resizing }"
        :style="{ height: dialogHeight + 'px' }"
    >
      <v-card-title>
        <span class="headline">Currency Deprecate</span>
      </v-card-title>
      <v-card-text class="resizable-card__body">
        <v-row dense>
          <v-col cols="12" sm="4" md="4">
            <r-currency-deprecate-mode :model.sync="mode"/>
          </v-col>
        </v-row>
        <v-row dense class="pt-4">
          <v-expansion-panels v-model="panels">
            <r-guard-panel :hidden="mode.id === 0" :model.sync="model.guard"/>
            <r-reward-bunch-panel
                :hidden="mode.id === 0"
                :model.sync="model.rewardBunch"
                title="Rewards"
                label="Bunch:"
                :percent="true"
            />
          </v-expansion-panels>
        </v-row>
      </v-card-text>
      <v-card-actions class="resizable-card__actions">
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>Cancel</v-btn>
        <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
      </v-card-actions>
      <div
          class="resize-handle"
          @mousedown.stop.prevent="startResize"
      ></div>
    </v-card>
  </v-dialog>
</template>

<script>
import { ViewRules } from "@/common/ViewRules";
import { CurrencyDeprecate } from "@/modules/redactor/models/currency/CurrencyDeprecate";
import { CurrencyDeprecateMode } from "@/modules/redactor/models/currency/CurrencyDeprecateMode";

import RCurrencyDeprecateMode from "@/modules/redactor/views/currency/r-currency-deprecate-mode.vue";
import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RRewardBunchPanel from "@/modules/redactor/views/reward/r-reward-bunch-panel.vue";

export default {
  name: "r-currency-deprecate-dialog",
  components: { RRewardBunchPanel, RGuardPanel, RCurrencyDeprecateMode },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new CurrencyDeprecate(),
    rules: ViewRules.READONLY,
    panels: [],
    dialogWidth: 575,
    dialogHeight: 468,
    resizing: false,
    resizeStartX: 0,
    resizeStartY: 0,
    resizeStartWidth: 575,
    resizeStartHeight: 468,
    viewportPadding: 32
  }),
  computed: {
    mode: {
      get() {
        return this.model ? this.model.mode : CurrencyDeprecateMode.DISABLED;
      },
      set(value) {
        this.model.mode = value;
      }
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new CurrencyDeprecate();
      this.panels = [];
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.empty()) {
        this.resolve && this.resolve(null);
        this.discard();
      } else if (this.model.valid()) {
        this.resolve && this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject && this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
      this.stopResize();
    },
    startResize(e) {
      this.resizing = true;
      this.resizeStartX = e.clientX;
      this.resizeStartY = e.clientY;
      this.resizeStartWidth = this.dialogWidth;
      this.resizeStartHeight = this.dialogHeight;
      window.addEventListener("mousemove", this.onResize);
      window.addEventListener("mouseup", this.stopResize);
    },
    onResize(e) {
      if (!this.resizing) return;

      const dx = e.clientX - this.resizeStartX;
      const dy = e.clientY - this.resizeStartY;

      let newWidth = this.resizeStartWidth + dx;
      let newHeight = this.resizeStartHeight + dy;

      const minWidth = 420;
      const minHeight = 280;

      if (newWidth < minWidth) newWidth = minWidth;
      if (newHeight < minHeight) newHeight = minHeight;

      this.dialogWidth = newWidth;
      this.dialogHeight = newHeight;
    },
    stopResize() {
      if (!this.resizing) return;
      this.resizing = false;
      window.removeEventListener("mousemove", this.onResize);
      window.removeEventListener("mouseup", this.stopResize);
    }
  },
  watch: {
    mode() {
      this.panels = [];
    }
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onResize);
    window.removeEventListener("mouseup", this.stopResize);
  }
};
</script>

<style scoped>
.resizable-card {
  position: relative;
  display: flex;
  flex-direction: column;
}
.resizable-card__body {
  flex: 1;
  overflow: auto;
}
.resizable-card__actions {
  flex-shrink: 0;
}
.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
  cursor: se-resize;
  border-right: 2px solid rgba(0, 0, 0, 0.3);
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
}
.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>